import React from "react";
import { Callout, IconName, Intent, MaybeElement } from "@blueprintjs/core";

export interface IMessageBubbleProps {
  header?: string;
  innerMessage: string;
  intent?: Intent;
  icon?: IconName | MaybeElement;
}

export const MessageBubble: React.FunctionComponent<IMessageBubbleProps> = ({
  header,
  innerMessage,
  intent = Intent.DANGER,
  icon,
}) => {
  return (
    <Callout
      intent={intent}
      title={header}
      style={{ marginBottom: "1rem" }}
      icon={icon}
    >
      <div>{innerMessage}</div>
    </Callout>
  );
};
